import { index, integer, sqliteTable, text } from "drizzle-orm/sqlite-core";
import { timestamps } from "@/db/columns.helpers";
import { user } from "./auth";
import { buddyConnection } from "./buddy";

export const USER_REPORT_REASON = [
  "harassment",
  "spam",
  "safety",
  "inappropriate_content",
  "fake_profile",
  "other",
] as const;
export type UserReportReason = (typeof USER_REPORT_REASON)[number];

export const USER_REPORT_STATUS = [
  "open",
  "reviewing",
  "resolved",
  "dismissed",
] as const;
export type UserReportStatus = (typeof USER_REPORT_STATUS)[number];

export const USER_REPORT_SEVERITY = ["low", "medium", "high"] as const;
export type UserReportSeverity = (typeof USER_REPORT_SEVERITY)[number];

export const USER_REPORT_TARGET_TYPE = [
  "profile",
  "connection",
  "post",
  "activity_post",
  "activity_session",
  "hiive_membership",
  "event_booking_attendee",
] as const;
export type UserReportTargetType = (typeof USER_REPORT_TARGET_TYPE)[number];

export const userReport = sqliteTable(
  "user_report",
  {
    id: integer("id").primaryKey({ autoIncrement: true }),

    reporterId: text("reporter_id")
      .notNull()
      .references(() => user.id, { onDelete: "cascade" }),
    reportedUserId: text("reported_user_id")
      .notNull()
      .references(() => user.id, { onDelete: "cascade" }),
    connectionId: integer("connection_id").references(
      () => buddyConnection.id,
      {
        onDelete: "set null",
      },
    ),

    targetType: text("target_type")
      .notNull()
      .$type<UserReportTargetType>()
      .default("profile"),
    reason: text("reason").notNull().$type<UserReportReason>(),
    details: text("details"),
    severity: text("severity")
      .notNull()
      .$type<UserReportSeverity>()
      .default("medium"),
    status: text("status").notNull().$type<UserReportStatus>().default("open"),

    sourceSurface: text("source_surface"),
    metadata: text("metadata", { mode: "json" }).$type<
      Record<string, unknown>
    >(),

    reviewedByUserId: text("reviewed_by_user_id").references(() => user.id, {
      onDelete: "set null",
    }),
    reviewedAt: integer("reviewed_at", { mode: "timestamp" }),
    resolutionNote: text("resolution_note"),

    ...timestamps,
  },
  (table) => [
    index("user_report_reporter_idx").on(table.reporterId),
    index("user_report_reported_user_idx").on(table.reportedUserId),
    index("user_report_status_idx").on(table.status),
    index("user_report_created_idx").on(table.createdAt),
    index("user_report_connection_idx").on(table.connectionId),
  ],
);

export type UserReport = typeof userReport.$inferSelect;
export type UserReportInsert = typeof userReport.$inferInsert;
